// crm namespace — Team (owner invite/list/resend/remove) and the /admin/join accept page
// (docs/crm-module/crm-api-contract.md "Team", P3, lane F5).
// Flat dotted keys, the same set in fr / en / es (i18n/__tests__/symmetry.test.js).
export default {
  fr: {
    "team.title": "Équipe",
    "team.subtitle": "Invitez une personne à vous aider à faire tourner le cabinet.",
    "team.ownerLabel": "Titulaire",
    "team.inviteEmailLabel": "Adresse e-mail",
    "team.invitePlaceholder": "collegue@exemple.com",
    "team.inviteSubmit": "Inviter",
    "team.invited": "Invitation envoyée",
    "team.invitedOn": "Invité(e) le {date}",
    "team.acceptedOn": "A rejoint le {date}",
    "team.resend": "Renvoyer l'invitation",
    "team.resendSent": "Invitation renvoyée",
    "team.remove": "Retirer",
    "team.removeTitle": "Retirer {email} de l'équipe ?",
    "team.removeBody": "Cette personne ne pourra plus se connecter à ce cabinet.",
    "team.removed": "{email} a été retiré(e)",
    "team.empty": "Personne d'autre n'a accès pour le moment.",
    "join.title": "Rejoindre {practice}",
    "join.subtitle": "Connectez-vous avec l'adresse e-mail qui a reçu l'invitation.",
    "join.noToken": "Ce lien d'invitation est incomplet : le jeton est manquant.",
    "join.signedInAs": "Connecté(e) en tant que {email}",
    "join.accepting": "Rejoindre l'équipe…",
    "join.mismatchTitle": "Ce n'est pas le bon compte",
    "join.mismatchBody": "Cette invitation a été envoyée à une autre adresse. Vous êtes actuellement connecté(e) en tant que {email}.",
    "join.switchAccount": "Se connecter avec une autre adresse",
    "join.expiredTitle": "Cette invitation a expiré",
    "join.expiredBody": "Demandez au titulaire du cabinet d'en envoyer une nouvelle.",
    "join.genericError": "Cette invitation n'a pas pu être acceptée. Réessayez.",
    "join.success": "Bienvenue dans l'équipe",
    "join.goToDashboard": "Aller au tableau de bord",
  },
  en: {
    "team.title": "Team",
    "team.subtitle": "Invite someone to help run the practice.",
    "team.ownerLabel": "Owner",
    "team.inviteEmailLabel": "Email address",
    "team.invitePlaceholder": "colleague@example.com",
    "team.inviteSubmit": "Invite",
    "team.invited": "Invite sent",
    "team.invitedOn": "Invited {date}",
    "team.acceptedOn": "Joined {date}",
    "team.resend": "Resend invite",
    "team.resendSent": "Invite resent",
    "team.remove": "Remove",
    "team.removeTitle": "Remove {email} from the team?",
    "team.removeBody": "They will no longer be able to sign in to this practice.",
    "team.removed": "{email} removed",
    "team.empty": "No one else has access yet.",
    "join.title": "Join {practice}",
    "join.subtitle": "Sign in with the email your invite was sent to.",
    "join.noToken": "This invite link is missing its token.",
    "join.signedInAs": "Signed in as {email}",
    "join.accepting": "Joining the team…",
    "join.mismatchTitle": "Wrong account",
    "join.mismatchBody": "This invite was sent to a different address. You're signed in as {email}.",
    "join.switchAccount": "Sign in with a different email",
    "join.expiredTitle": "This invite has expired",
    "join.expiredBody": "Ask the practice owner to send a new one.",
    "join.genericError": "This invite could not be accepted. Try again.",
    "join.success": "Welcome to the team",
    "join.goToDashboard": "Go to the dashboard",
  },
  es: {
    "team.title": "Equipo",
    "team.subtitle": "Invita a alguien para que te ayude a llevar la consulta.",
    "team.ownerLabel": "Titular",
    "team.inviteEmailLabel": "Correo electrónico",
    "team.invitePlaceholder": "colega@ejemplo.com",
    "team.inviteSubmit": "Invitar",
    "team.invited": "Invitación enviada",
    "team.invitedOn": "Invitado/a el {date}",
    "team.acceptedOn": "Se unió el {date}",
    "team.resend": "Reenviar invitación",
    "team.resendSent": "Invitación reenviada",
    "team.remove": "Quitar",
    "team.removeTitle": "¿Quitar a {email} del equipo?",
    "team.removeBody": "Esta persona ya no podrá acceder a esta consulta.",
    "team.removed": "{email} fue eliminado/a",
    "team.empty": "Todavía nadie más tiene acceso.",
    "join.title": "Unirse a {practice}",
    "join.subtitle": "Inicia sesión con el correo al que se envió la invitación.",
    "join.noToken": "A este enlace de invitación le falta el token.",
    "join.signedInAs": "Sesión iniciada como {email}",
    "join.accepting": "Uniéndose al equipo…",
    "join.mismatchTitle": "Esta no es la cuenta correcta",
    "join.mismatchBody": "Esta invitación se envió a otra dirección. Has iniciado sesión como {email}.",
    "join.switchAccount": "Iniciar sesión con otro correo",
    "join.expiredTitle": "Esta invitación ha caducado",
    "join.expiredBody": "Pide a la persona titular de la consulta que envíe una nueva.",
    "join.genericError": "No se pudo aceptar esta invitación. Inténtalo de nuevo.",
    "join.success": "Bienvenido/a al equipo",
    "join.goToDashboard": "Ir al panel",
  },
};
